import { takeLatest, put, call } from 'redux-saga/effects';

import FireBaseTools from '../utils/firebase';
import { showError } from '../actions/dialogs';
import {
  CONFIRM_PASSWORD_RESET_LINK, validResetPasswordLink, inValidResetPasswordLink,
  CONFIRM_PASSWORD_RESET, passwordResetSuccessful, passwordResetFailure,
  CONFIRM_EMAIL_VERIFICATION_LINK, emailVerificationSuccess, emailVerificationFailed,
} from '../actions/firebase';

function* confirmPasswordResetLinkSaga(action) {
  try {
    const response = yield call(FireBaseTools.verifyPasswordResetCode, action.oobCode);
    if (response) {
      yield put(validResetPasswordLink());
    } else {
      throw new Error('Invalid password reset link');
    }
  } catch (e) {
    yield put(inValidResetPasswordLink());
  }
}

function* confirmPasswordResetSaga(action) {
  try {
    const response = yield call(FireBaseTools.setNewPassword, action.code, action.newPassword);
    if (response) {
      yield put(passwordResetSuccessful(response));
    } else {
      throw new Error('Invalid password reset link');
    }
  } catch (e) {
    console.log('err', e);
    yield put(showError('Reset Password Failure', e.message));
    yield put(passwordResetFailure(e));
  }
}

function* verifyEmailSaga(action) {
  try {
    const response = yield call(FireBaseTools.applyVerificationCode, action.code);
    if (response) {
      yield put(emailVerificationSuccess(response));
    } else {
      throw new Error('Invalid email verification link');
    }
  } catch (e) {
    yield put(emailVerificationFailed());
  }
}

function* watchConfirmPasswordResetLinkSaga() {
  yield takeLatest(CONFIRM_PASSWORD_RESET_LINK, confirmPasswordResetLinkSaga);
}
function* watchConfirmPasswordResetSaga() {
  yield takeLatest(CONFIRM_PASSWORD_RESET, confirmPasswordResetSaga);
}
function* watchEmailVerificationSaga() {
  yield takeLatest(CONFIRM_EMAIL_VERIFICATION_LINK, verifyEmailSaga);
}

export {
  watchConfirmPasswordResetLinkSaga,
  watchConfirmPasswordResetSaga,
  watchEmailVerificationSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/firebase.js